import memoryAxiosInstance from '../../../core/api/memoryAxios';
import { TAG_TYPE } from '../hooks/use-tags';

export const tagService = {
  list: async (userUuid: string, type?: TAG_TYPE) => {
    const endpoint = type
      ? `/api/v1/tags/${userUuid}/${type}`
      : `/api/v1/tags/${userUuid}`;
    const response = await memoryAxiosInstance.get(endpoint);
    return response.data;
  },
  listByVideoAula: async (userUuid: string, externalId: string) => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/flashcards/${userUuid}/video-aula/${externalId}`
    );
    return response.data || [];
  },
  listSubjects: async (userUuid: string, disciplineUuid?: string) => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/tags/${userUuid}/subjects/by-discipline`,
      {
        params: {
          disciplineUuid,
        },
      }
    );
    return response.data;
  },
  get: async (userUuid: string, uuid: string) => {
    const response = await memoryAxiosInstance.get(
      `/api/v1/tags/${userUuid}/get-by-uuid/${uuid}`
    );
    return response.data;
  },
};
